import { ProductCategoryEnum } from '@mwe/constants';
import dayjs from 'dayjs';
import { AddressGroup } from './address/address-group.model';
import { Address, AddressProducts } from './address/address.model';

// TODO utils in model lib net schoen
// temp fix to prevent circular dependencies

export const getContractSummaryUrl = (documentUrl: string, tariffPart: string): string => {
  return documentUrl.concat('vertragszusammenfassung-superschnell-' + tariffPart + '/');
};

export const everyTrue = (...values): boolean => {
  return values.every(b => b === true);
};

export const isEqualCategoryString = (categoryA: string, categoryB: string): boolean => {
  return categoryA && categoryB ? categoryA.toLowerCase() === categoryB.toLowerCase() : false;
};

export const parseISODate = (isoDate: string): Date => {
  return dayjs(isoDate).toDate();
};

export function checkAddressProductsForAddressGroupUpdates(addressProducts: AddressProducts[], updates: AddressGroup[]) {
  const addresses = addressProducts.map(addressProduct => addressProduct.address);

  return checkAddressesForGroupUpdates(addresses, updates);
}

export function checkAddressesForGroupUpdates(addresses: Address[], updates: AddressGroup[]) {
  return addresses.map(address => {
    const update = updates.find(u => u.addressCode === address.addressGroup.addressCode);

    if (update) {
      return {
        ...address,
        addressGroup: {
          ...update,
          matchedGroup: true,
        },
      };
    }

    return address;
  });
}

export const isProductCategoryFernwaerme = (value: string): boolean => {
  return isProductCategory(value, ProductCategoryEnum.FERNWAERME);
};

export const isProductCategory = (value: string, categoryEnum: ProductCategoryEnum): boolean => {
  return !!value && value?.toUpperCase() === ProductCategoryEnum?.[categoryEnum]?.toUpperCase();
};
